import React from "react";
import { Link } from "react-router-dom";
import logoFull from "./../assets/images/logo-full.png";
import CTA from "./CTA";
import { Col, Container, Row } from "react-bootstrap";
import Payments from "./../assets/images/credit-card-logos.webp";
import ContactUsModal from "./Modals/ContactUsModal";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaGooglePlus } from "react-icons/fa";
import { IoLogoFacebook, IoSend } from "react-icons/io5";
import { AiFillInstagram, AiOutlineGooglePlus } from "react-icons/ai";
import "./Footer.scss";
const Footer = () => {
  // const url = window.location.href;
  const pathname = window.location.pathname;
  /*  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  */

  return (
    <>
      {pathname == "/" && (
        <div className="footercta">
          <Container>
            <Row>
              <Col>
                <CTA />
              </Col>
            </Row>
          </Container>
        </div>
      )}

      <footer className="footer-bg" data-bg-color="var(--tg-common-color-dark)">
        <div className="footer__top-wrap">
          <div className="container">
            <div className="row">
              {/* <div className="col-md-3">
                                <div className="footer-widget">
                                    <div className="footer__about">
                                        <h4 className="fw-title">About</h4>
                                        
                                        <p>Digital learning for CBSE & ICSE 9-12 with computer science and non-science subjects, offering pre-recorded videos for self-paced learning.</p>
                                        <ul className="list-wrap m-0 p-0">
                                           
                                            <li className="socials">
                                                <Link to={'/'}><i className="fab fa-facebook-f"></i></Link>
                                                <Link to={'/'}><i className="fab fa-twitter"></i></Link>
                                                <Link to={'/'}><i className="fab fa-whatsapp"></i></Link>
                                                <Link to={'/'}><i className="fab fa-linkedin-in"></i></Link>
                                                <Link to={'/'}><i className="fab fa-youtube"></i></Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
              <div className="col-md-3">
                <div className="footer-widget widget_nav_menu">
                  <h4 className="fw-title">Quick Links</h4>
                  <ul className="list-wrap">
                    <li>
                      <Link to={"/"}>Home</Link>
                    </li>
                    <li>
                      <Link to={"/about-us"}>About us</Link>
                    </li>
                    <li>
                      <Link to={"/contact-us"}>Contact</Link>
                    </li>
                    {/* <li><Link to={'/'}>Downlaod App</Link></li> */}
                    {/* <li><Link to={'/'}>Refund</Link></li> */}
                    <li>
                      <Link to={"/blog"}>Blog</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3">
                <div className="footer-widget widget_nav_menu">
                  <h4 className="fw-title">Courses</h4>
                  <ul className="list-wrap">
                    <li>
                      <Link to={"/courses/icse/icse-class-9"}>
                        ICSE Class 9
                      </Link>
                    </li>
                    <li>
                      <Link to={"/courses/icse/icse-class-10"}>
                        ICSE Class 10
                      </Link>
                    </li>
                    <li>
                      <Link to={"/courses/icse/icse-class-11"}>
                        ICSE Class 11
                      </Link>
                    </li>
                    <li>
                      <Link to={"/courses/icse/icse-class-12"}>
                        ICSE Class 12
                      </Link>
                    </li>
                    <li>
                      <Link to={"/courses/cbse/cbse-class-12"}>
                        CBSE Class 12
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3">
                <div className="footer-widget widget_nav_menu">
                  <h4 className="fw-title"> Get in Touch </h4>
                  <ul className="list-wrap">
                    <li className="address">EFH Tech Service LLP </li>
                    <li className="number">
                      13/2, New Road, Opposite MKP College, Dehradun,
                      Uttarakhand, 248001
                    </li>
                  </ul>
                  {/* <h4 className="fw-title">efhdigitalminds@gmail.com</h4> */}
                  {/* <h4 className="fw-title"> GSTIN : 05AAKFE7114R1Z0</h4> */}
                  <span className="text-white">Email:</span>{" "}
                  {/* <a href="mailto:efhfromhome.prosper.india@gmail.com">efhfromhome.prosper.india@gmail.com</a> */}
                  <a
                    className="text-white"
                    href="mailto:efhdigitalminds@gmail.com"
                  >
                    efhdigitalminds@gmail.com
                  </a>
                  <br />
                  <span className="text-white">Mobile:</span>{" "}
                  {/* <a href="mailto:efhfromhome.prosper.india@gmail.com">efhfromhome.prosper.india@gmail.com</a> */}
                  <a className="text-white" href="tel:+917895926600">
                    +91-7895926600
                  </a>
                  <h4 className="fw-title mb-2 mt-2"> Follow Us : </h4>
                  <a
                    href="https://www.facebook.com/profile.php?id=61574141350108"
                    target="_blank"
                  >
                    {" "}
                    <FaFacebook className="text-white me-2" size={24} />{" "}
                  </a>
                  <a
                    href="https://www.instagram.com/education.from.home/"
                    target="_blank"
                  >
                    {" "}
                    <FaInstagram className="text-white  me-2" size={24} />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/efh-education-from-home-8416b03a4/"
                    target="_blank"
                  >
                    {" "}
                    <FaLinkedin className="text-white  me-2" size={24} />
                  </a>
                </div>
              </div>
              <div className="col-md-3">
                <div className="footer-widget widget_nav_menu">
                  <h4 className="fw-title"> Online Payments</h4>
                  <img src={Payments} alt="" width={140} />
                  {/*   <h4 className="fw-title mt-3"> Subscribe Newsletter </h4> */}
                  {/* <form>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control"
                        // style={{ "border-radius": "3px 0 0 3px" }}
                        placeholder="Enter Email ID"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                      <span
                        className="input-group-text bg-primary links"
                        id="basic-addon2"
                      >
                        <IoSend className="text-white" />{" "}
                      </span>
                    </div>
                  </form> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright__wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="copyright__text">
                  <p>Copyright 2025 Efhonline.com. All rights reserved.</p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="copyright__menu">
                  <ul className="list-wrap d-flex flex-wrap justify-content-center justify-content-lg-end">
                    <li>
                      <Link to={"/privacy-policy"}>Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to={"/terms-and-conditions"}>
                        Terms & Conditions
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
